// shared/domain/propertyTypes.js

export const PROPERTY_TYPE_MAP = {
  Apartment: 'Piso',
  Flat: 'Piso',

  House: 'Casa, chalet, unifamiliar',
  Villa: 'Casa, chalet, unifamiliar',
  Detached: 'Casa, chalet, unifamiliar',

  'Commercial space': 'Local',
  'Individual office': 'Oficina individual',
  Building: 'Edificio',
};

/**
 * Normaliseert een property type string zodat deze altijd matcht met PROPERTY_TYPE_MAP
 * - trimt spaties
 * - maakt eerste letter hoofdletter, rest kleine letters
 * - behoudt spaties tussen woorden
 */
export function normalizePropertyType(str) {
  if (!str || typeof str !== 'string') return str;
  const trimmed = str.trim();
  // Speciale gevallen met meerdere woorden
  if (PROPERTY_TYPE_MAP[trimmed]) return trimmed;
  // Probeer met hoofdletter eerste letter, rest klein
  const normalized = trimmed
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  return PROPERTY_TYPE_MAP[normalized] ? normalized : trimmed;
}
